import '@wearediagram/wsol.accordion';
import '@wearediagram/wsol.tabs';

export async function DiagramTabcordions() {
    var timeout = false,
        delay = 250,
        matches = false;

    var breakpointCheck = function() {
        if (window.innerWidth < 896) {
            if (matches) {
                document.dispatchEvent(new CustomEvent('breakpointBravoUnmatch'));
                matches = false;
            }
        } else {
            if (!matches) {
                document.dispatchEvent(new CustomEvent('breakpointBravoMatch'));
                matches = true;
            }
        }
    };

    // window.resize event listener
    window.addEventListener('resize', function () {
        clearTimeout(timeout);
        timeout = setTimeout(breakpointCheck, delay);
    });

    // tabcordion init
    $(document).on('breakpointBravoMatch', function () {
        $('.js-tabcordions').each(function () {
            if ($(this).find('.js-tab-container').data('wsol.accordion') !== undefined) {
                $(this).find('.js-tab-container').data('wsol.accordion').destroy();
            }
            $(this).wsol_tabs();
        });
    });

    $(document).on('breakpointBravoUnmatch', function () {
        $('.js-tabcordions').each(function () {
            if ($(this).data('wsol.tabs') !== undefined) {
                $(this).data('wsol.tabs').destroy();
            }
            $(this).find('.js-tab-container').wsol_accordion({
                headerSelector: '.js-tab-header',
                bodySelector: '.tab-content',
                itemSelector: '.tab-pane'
            });
        });
    });

    if (window.innerWidth < 896) {
        document.dispatchEvent(new CustomEvent('breakpointBravoUnmatch'));
        matches = false;
    } else {
        document.dispatchEvent(new CustomEvent('breakpointBravoMatch'));
        matches = true;
    }

};